import { FormControl, FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedFormField } from './appliance-details-stepped-form-field.enum';
import { ModelAndSerialNumberFieldset } from './model-and-serial-number-fieldset.interface';
import { PersonalDetailsForm } from './personal-details-form.interface';

export interface ApplianceDetailsSteppedForm {
  [ApplianceDetailsSteppedFormField.ApplianceCategoryCode]: FormControl<
    string | null
  >;
  [ApplianceDetailsSteppedFormField.ApplianceCode]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.BrandCode]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.ModelAndSerialNumber]: FormGroup<ModelAndSerialNumberFieldset>;
  [ApplianceDetailsSteppedFormField.PurchasePrice]: FormControl<string | null>;
  [ApplianceDetailsSteppedFormField.PurchaseDate]: FormControl<Date | null>;
  [ApplianceDetailsSteppedFormField.PersonalDetails]: FormGroup<PersonalDetailsForm>;
}
